import { render } from "./LegacyNoticeView.vue?vue&type=template&id=77e980a8"
import script from "./LegacyNoticeView.vue?vue&type=script&lang=js"
export * from "./LegacyNoticeView.vue?vue&type=script&lang=js"

import "./LegacyNoticeView.vue?vue&type=style&index=0&id=77e980a8&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__